import { postNotification } from "../../../../components/utilities/Notifications";
import { fetchDataArray } from './dataFetching'
import { getDictionaries } from './dictionaries';
import { getTopCutPairingList, preparePairingList } from './preparePairing';
import { preparePlayerList } from './preparePlayer';

export const check = async (
    event,
    setPairings,
    setBrackets,
    setHasRematch,
    setLoadingMessage,
    setIsTopCut
  ) => {
  try {
    const isTopCut = event?.bracketPairings && event?.topCut && event?.podRound >= 1
    const currentRound = event?.currentRound;
    const isDoubleElimination = Boolean(event.doubleElimination);

    setLoadingMessage("Loading players...");
    let playerList = await fetchDataArray('player', event?.id || "", currentRound, isDoubleElimination);
    setLoadingMessage("Loading pairings...");
    let pairingList = event?.boardGameEvent
      ? await fetchDataArray('seatedPairing', event?.id || "", currentRound, isDoubleElimination)
      : !event?.teamEvent
      ? await fetchDataArray('pairing', event?.id || "", currentRound, isDoubleElimination)
      : event?.teamEvent
      ? await fetchDataArray('teamPairing', event?.id || "", currentRound, isDoubleElimination)
      : [];


    pairingList = preparePairingList(pairingList)
    playerList = preparePlayerList(playerList)

    if (isTopCut) {
      const topCutPairingList = getTopCutPairingList(pairingList, event?.podRound)
      const topCutPlayerList = playerList.filter(player => player?.podNum === 1)

      const { bracketDict, pairingDict } = getDictionaries(
        topCutPlayerList,
        topCutPairingList,
        event?.doubleElimination,
        setHasRematch,
        event?.podRound || 1
      )


      setPairings(pairingDict);
      setBrackets(bracketDict);

      setIsTopCut(isTopCut)
    } else {
      const { bracketDict, pairingDict } = getDictionaries(
        playerList,
        pairingList,
        event?.doubleElimination,
        setHasRematch
      ) 
  
      setPairings(pairingDict);
      setBrackets(bracketDict);
    }
  } catch (err) {
    postNotification("error", err);
  } finally {
    setLoadingMessage(null);
  }
};